<template>
  <div class="container container-fluid p-4 p-sm-5">
    <loading v-show="showLoader"/>

    <ul class="nav nav-pills mb-3 mb-md-5" id="pills-tab" role="tablist">
      <li class="nav-item">
        <a class="nav-link active data-row" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">
          <img :src="require('@/assets/images/feedback-icon-1.png')" alt="Policy Acquisition">
          <p>Policy Acquisition</p>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link data-row" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">
          <img :src="require('@/assets/images/feedback-icon-2.png')" alt="Policy Acquisition">
          <p>Claims Feedback</p>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link data-row" id="pills-contact-tab" data-toggle="pill" href="#pills-contact" role="tab" aria-controls="pills-contact" aria-selected="false">
          <img :src="require('@/assets/images/feedback-icon-3.png')" alt="Policy Acquisition">
          <p>Overall Feedback</p>
        </a>
      </li>
    </ul>

    <div class="tab-content" id="pills-tabContent">
      <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
        <div class="row mb-2">
          <div class="col-12">
            <ul class="list-inline">
              <li class="list-inline-item"><h1>Policy Listing</h1></li>
              <form action="" class="float-right ml-auto">
                <li class="list-inline-item">
                  <ul class="list-inline">
                    <li class="list-inline-item">
                      <div class="field">
                        <input type="text" id="texto" class="input-placeholder input-search jbl-search-field" placeholder="Search here..." v-on:keyup="filterSearch" />
                      </div>
                    </li>
                    <li class="list-inline-item">
                      <div style="width:110px;">
                        <div class="floating-label">
                          <select name="customer_city" onchange="this.setAttribute('value', this.value);" value="" class="floating-select jbl-plc-search" v-on:change="claimFilter($event)">
                          <option value="self" selected>Self</option>
                          <option value="nominated">Nominated</option>
                          </select> <span class="highlight"></span>
                          <div class="jbl-custom-select"></div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>
              </form>
            </ul>
          </div>
        </div>

        <!-- -----------------Self List ----------------->
        <div id="self-Claims" v-show="self_claim_area">
          <table class="claim-listing">
            <tbody>
              <tr v-on:click="show_feedback_form($event, 'policy', self_policy.id)" :id="self_policy.id" v-for="self_policy in customer_self_policies_filterd" :key="self_policy.id">
              <td class="jbl-responsive-td data-img">
                <img :src="self_policy.product_card" alt="image"></td>
              <td class="jbl-table-heading jbl-responsive-td">{{ self_policy.product_name }}</td>
              <td class="jbl-responsive-td" v-if="self_policy.policy_no != null">
                <div class="jbl-flex-td">
                  <div class="jbl-date-td jbl-date-heading">Policy No.</div>
                  <div class="jbl-date-td">{{ self_policy.policy_no}}</div>
                </div>
              </td>
              <td class="jbl-responsive-td" v-else>
                <div class="jbl-flex-td">
                  <div class="jbl-date-td jbl-date-heading">Order No.</div>
                  <div class="jbl-date-td">{{ self_policy.tcn_no}}</div>
                </div>
              </td>
              <td class="jbl-responsive-td">
                <div class="jbl-flex-td">
                  <div class="jbl-date-td jbl-date-heading">Package Price</div>
                  <div class="jbl-date-td"><span class="jbl-text-primary">{{ self_policy.currency }}</span> {{ self_policy.paid_amount }}</div>
                </div>
              </td>
              <td class="jbl-responsive-td">
                <div class="jbl-flex-td">
                  <div class="jbl-date-td jbl-date-heading">Expires at:</div>
                  <div class="jbl-date-td">{{ formatDate(self_policy.expires_at) }}</div>
                </div>
              </td>
              <td class="jbl-responsive-td"><div class="jbl-status-approve text-capitalize">{{ self_policy.consumer_status }}</div></td>
              <td class="jbl-responsive-td in-w-60">
                <!-- <i class="fa fa-chevron-right"></i> -->
                <img class="img-fluid in-w-10" :src="require('@/assets/images/arrow-down-icon.svg')" alt="icon">
              </td>
            </tr>
            </tbody>
          </table>
          <h2 style="color: rgba(0, 0, 0, 0.3) !important" v-if="customer_self_policies_filterd.length === 0">No Self Policy Found</h2>
        </div>
        <!-- -----------------Self List End ----------------->

        <!-- -----------------Nominated List ----------------->
        <div id="nomiated-Claims" v-show="nominated_claim_area">
          <table class="claim-listing">
            <tbody>
            <tr v-on:click="show_feedback_form($event, 'policy', nominated_policy.id)" :id="nominated_policy.id" v-for="nominated_policy in customer_nominated_policies_filterd" :key="nominated_policy.id">
              <td class="jbl-responsive-td data-img">
                <img :src="nominated_policy.product_card" alt="image"></td>
              <td class="jbl-table-heading jbl-responsive-td">{{ nominated_policy.product_name }}</td>
              <td class="jbl-responsive-td" v-if="nominated_policy.policy_no != null">
                <div class="jbl-flex-td">
                  <div class="jbl-date-td jbl-date-heading">Policy No.</div>
                  <div class="jbl-date-td">{{ nominated_policy.policy_no}}</div>
                </div>
              </td>
              <td class="jbl-responsive-td" v-else>
                <div class="jbl-flex-td">
                  <div class="jbl-date-td jbl-date-heading">Order No.</div>
                  <div class="jbl-date-td">{{ nominated_policy.tcn_no}}</div>
                </div>
              </td>
              <td class="jbl-responsive-td">
                <div class="jbl-flex-td">
                  <div class="jbl-date-td jbl-date-heading">Package Price</div>
                  <div class="jbl-date-td"><span class="jbl-text-primary">{{ nominated_policy.currency }}</span> {{ nominated_policy.paid_amount }}</div>
                </div>
              </td>
              <td class="jbl-responsive-td">
                <div class="jbl-flex-td">
                  <div class="jbl-date-td jbl-date-heading">Expires at:</div>
                  <div class="jbl-date-td">{{ formatDate(nominated_policy.expires_at) }}</div>
                </div>
              </td>
              <td class="jbl-responsive-td"><div class="jbl-status-approve text-capitalize">{{ nominated_policy.consumer_status }}</div></td>
              <td class="jbl-responsive-td in-w-60">
                <!-- <i class="fa fa-chevron-right"></i> -->
                <img class="img-fluid in-w-10" :src="require('@/assets/images/arrow-down-icon.svg')" alt="icon">
              </td>
            </tr>
            </tbody>
          </table>
          <h2 style="color: rgba(0, 0, 0, 0.3) !important" v-if="customer_nominated_policies_filterd.length === 0">No Nominated Policy Found</h2>
        </div>
      </div>
      <!-- -----------------Nominated List End ----------------->

      <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
        <div class="row mb-2">
          <div class="col-12">
            <ul class="list-inline">
              <li class="list-inline-item"><h1>Claim Listing</h1></li>
              <form action="" class="float-right ml-auto">
                <li class="list-inline-item">
                  <ul class="list-inline">
                    <li class="list-inline-item">
                      <div class="field">
                        <input type="text" id="texto" class="input-placeholder input-search jbl-search-field" placeholder="Search here..." v-on:keyup="filterSearchClaim" />
                      </div>
                    </li>
                    <li class="list-inline-item">
                      <div style="width:110px;">
                        <div class="floating-label">
                          <select name="customer_city" onchange="this.setAttribute('value', this.value);" value="" class="floating-select jbl-plc-search" v-on:change="claimsFilter">
                          <option value="self" selected>Self</option>
                          <option value="nominated">Nominated</option>
                          </select> <span class="highlight"></span>
                          <div class="jbl-custom-select"></div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>
              </form>
            </ul>
          </div>
        </div>

        <!-- -----------------Self List ----------------->
        <div id="self-Claim" v-show="self_claims_area">
          <table class="claim-listing">
            <tbody>
            <tr v-on:click="show_feedback_form($event, 'claim', self_claim.id )" v-for="self_claim in self" :key="self_claim.id">
              <td class="jbl-responsive-td data-img">
                <img :src="self_claim.product_card" alt="image"></td>
              <td class="jbl-table-heading jbl-responsive-td">{{ self_claim.product_name }}</td>
              <td class="jbl-responsive-td">
                <div class="jbl-flex-td">
                  <div class="jbl-date-td jbl-date-heading">Claim No.</div>
                  <div class="jbl-date-td">{{ self_claim.claim_no }}</div>
                </div>
              </td>
              <td class="jbl-responsive-td">
                <div class="jbl-flex-td">
                  <div class="jbl-date-td jbl-date-heading">Date:</div>
                  <div class="jbl-date-td">{{ formatDate(self_claim.created_at) }}</div>
                </div>
              </td>
              <td class="jbl-responsive-td"><div class="jbl-status-approve text-capitalize">{{ self_claim.status }}</div></td>
              <td class="jbl-responsive-td in-w-60">
                <!-- <i class="fa fa-chevron-right"></i> -->
                <img class="img-fluid in-w-10" :src="require('@/assets/images/arrow-down-icon.svg')" alt="icon">
              </td>
            </tr>
            </tbody>
          </table>
          <h2 style="color: rgba(0, 0, 0, 0.3) !important " v-if="customer_self_policies_filterd.length === 0">No Self Policy Found</h2>
        </div>
        <!-- -----------------Self List End ----------------->

        <!-- -----------------Nominated List ----------------->
        <div id="nomiated-Claim" v-show="nominated_claims_area">
          <table class="claim-listing">
            <tbody>
            <tr v-on:click="show_feedback_form($event, 'claim', nominated_claim.id )" v-for="nominated_claim in nominated" :key="nominated_claim.id">
              <td class="jbl-responsive-td data-img">
                <img :src="nominated_claim.product_card" alt="image"></td>
              <td class="jbl-table-heading jbl-responsive-td">{{ nominated_claim.product_name }}</td>
              <td class="jbl-responsive-td">
                <div class="jbl-flex-td">
                  <div class="jbl-date-td jbl-date-heading">Claim No.</div>
                  <div class="jbl-date-td">{{ nominated_claim.claim_no }}</div>
                </div>
              </td>
              <td class="jbl-responsive-td">
                <div class="jbl-flex-td">
                  <div class="jbl-date-td jbl-date-heading">Date:</div>
                  <div class="jbl-date-td">{{ formatDate(nominated_claim.created_at) }}</div>
                </div>
              </td>
              <td class="jbl-responsive-td"><div class="jbl-status-approve text-capitalize">{{ nominated_claim.status }}</div></td>
              <td class="jbl-responsive-td in-w-60">
                <!-- <i class="fa fa-chevron-right"></i> -->
                <img class="img-fluid in-w-10" :src="require('@/assets/images/arrow-down-icon.svg')" alt="icon">
              </td>
            </tr>
            </tbody>
          </table>
          <h2 style="color: rgba(0, 0, 0, 0.3) !important " v-if="nominated.length === 0">No Self Policy Found</h2>
        </div>
        <!-- -----------------Nominated List End ----------------->
      </div>

      <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
        <div class="container">
          <div class="row">
            <div class="col-md-8 offset-md-2">
              <div class="jbl-rating-img">
                  <img :src="imgPath" id="RatingImage" alt="Rating Image">
                </div>
              <div class="jbl-rating-box">
                <h1 class="jbl-rating-heaing" style="text-align: center;">Rate Your Experience </h1>
                <h3 class="mt-5 mb-3 jbl-rating-subheading">{{ exp_title }} Experience!</h3>
                <form v-on:submit="OverAllFeedBack" id="OverAllFeedBack">
                  <div class="rating">
                    <input type="radio" name="rating" value="5" id="5" required @click="ChangeExperience(1)"><label for="5"><i class="fas fa-star"></i></label>
                    <input type="radio" name="rating" value="4" id="4" required @click="ChangeExperience(2)"><label for="4"><i class="fas fa-star"></i></label>
                    <input type="radio" name="rating" value="3" id="3" required @click="ChangeExperience(3)"><label for="3"><i class="fas fa-star"></i></label>
                    <input type="radio" name="rating" value="2" id="2" required @click="ChangeExperience(4)"><label for="2"><i class="fas fa-star"></i></label>
                    <input type="radio" name="rating" value="1" id="1" required @click="ChangeExperience(5)"><label for="1"><i class="fas fa-star"></i></label>
                  </div>
                  <div>
                    <div class="jbl-field">
                      <textarea type="text" class="jbl-dynamic-input" placeholder="Enter"></textarea>
                      <label class="jbl-dynamic-label">Description</label>
                    </div>
                  </div>
                  <div class="d-block text-center">
                    <button type="submit" class="jbl-btn-primary mx-auto text-uppercase">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div id="myModal" role="dialog" v-if="showFeedbackModal" class="modal show" style="display: block;" aria-modal="true">
      <div class="modal-dialog jbl-feedback-dialog modal-dialog-scrollable">
        <div class="modal-content py-3">
          <form v-on:submit="submit_review" id="submit_review">
            <div class="modal-body">
              <h1 style="color:ba0c2f; font-family:'Futura PT Medium'; text-align:center;">Feedback</h1>
              <div class="jbl-user-survey" v-for="fields in custom_fields">
                <h1 class="jbl-feedback-title d-block">{{ fields.label }}</h1>
                <div class="options hiddenradio radio-width-img">
                  <div style="position:relative;" v-for="default_values in fields.default_values">
                    <img :src="default_values.enable_icon" :for="default_values.id" @click="CheckMark(default_values.id, default_values.enable_icon)" >
                    <input class="jbl-radio-position" type="radio" :name="fields.field_name" :value="default_values.id" :key="default_values.field_name" :id="default_values.id" required>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer" style="border:none !important;">
              <div class="mx-auto text-center">
                <button type="submit" class="jbl-btn-primary mr-2">SUBMIT</button>
              <button type="button" class="jbl-btn-primary-2" data-dismiss="modal" @click="showFeedbackModal = false">CANCEL</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import loading from "@/components/Loading/Loading";
  import moment from "moment";

  export default {
    name: 'FeedBack',
    components: {
      loading
    },
    data() {
      return {
        showLoader: true,
        self_claims: {},
        nominated_claims: {},
        self: {},
        nominated: {},
        customer_self_policies: {},
        customer_nominated_policies: {},
        customer_self_policies_filterd: {},
        customer_nominated_policies_filterd: {},
        custom_fields: {},
        self_claim_area: true,
        nominated_claim_area: false,
        self_claims_area: true,
        nominated_claims_area: false,
        current_state: "self",
        current_states: "self",
        type: 0,
        id: 0,
        showFeedbackModal: false,
        exp_title : 'Nice',
        imgPath : require('@/assets/images/normal.svg'),
      };
    },
    created: function () {
      const self = this;
      self.getPolicies();
      self.getClaims();
    },
    methods: {
      CheckMark(id, img) {
        document.getElementById(id).checked = true;
      },
      formatDate(date) {
        return moment(date, "YYYY-MM-DD").format('DD-MMM-YYYY');
      },
      ChangeExperience(value) {
        const self = this;
        if (value == 5) {
          self.imgPath =  require('@/assets/images/very_bad.svg');
          self.exp_title = 'Very Bad';
        } else if(value == 4) {
          self.imgPath =  require('@/assets/images/bad.svg');
          self.exp_title = 'Bad';
        } else if(value == 3) {
          self.imgPath =  require('@/assets/images/normal.svg');
          self.exp_title = 'Nice';
        } else if(value == 2) {
          self.imgPath =  require('@/assets/images/good.svg');
          self.exp_title = 'Good';
        } else {
          self.imgPath =  require('@/assets/images/very_good.svg');
          self.exp_title = 'Very Good';
        }
      },
      async OverAllFeedBack(e) {
        e.preventDefault();
        const self = this;
        self.showLoader = true;
        var formData = new FormData(document.getElementById('OverAllFeedBack'));

        await axios.post("customer/feedback/store_app_feedback", formData).then(function (resp) {
          self.showLoader = false;
          if (resp.data.code === 200) {
            $toast.info(resp.data.message, { position: 'top-right' });
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      openEditModal(data) {
        this.$root.$emit('bv::show::modal', 'myModal');
      },
      async getPolicies() {
        const self = this;
        self.showLoader = true;
        await axios.get("customer/customer_policies_listing?status=active").then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            self.customer_self_policies = resp.data.data.policies;
            self.customer_nominated_policies = resp.data.data.nominated_policies;
            self.customer_self_policies_filterd = resp.data.data.policies;
            self.customer_nominated_policies_filterd = resp.data.data.nominated_policies;
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      claimFilter: function(e) {
        const self = this;
        self.current_state = e.target.value;
        self.self_claim_area = !self.self_claim_area;
        self.nominated_claim_area = !self.nominated_claim_area;
      },
      filterSearch(key) {
        const self = this;
        if (self.current_state == "self") {
          self.customer_self_policies_filterd = self.customer_self_policies.filter(
            (x) => x.title.toLowerCase().includes(key.target.value.toLowerCase())
          );
        } else {
          self.customer_nominated_policies_filterd = self.customer_nominated_policies.filter(
            (x) => x.title.toLowerCase().includes(key.target.value.toLowerCase())
          );
        }
      },
      async show_feedback_form(e, type, id) {
        const self = this;
        self.type = type;
        self.id = id;
        self.showLoader = true;
        await axios.post("customer/feedback/form_fields", { refer_for: type, refer_for_id: id }).then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            var obj_keys = Object.keys(resp.data.data.feedback_forms);
            self.custom_fields = resp.data.data.feedback_forms[obj_keys].custom_fields;
            self.showFeedbackModal = true;
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      async submit_review(e) {
        const self = this;
        e.preventDefault();
        self.showLoader = true;
        var formData = new FormData(document.getElementById('submit_review'));
        formData.append('refer_for', self.type);
        formData.append('refer_for_id', self.id);

        await axios.post('customer/feedback/store_feedback', formData).then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            $toast.success(resp.data.message, { position: 'top-right' });
            self.showFeedbackModal = false;
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      async getClaims() {
        const self = this;
        self.showLoader = true;
        await axios.get('customer/claims').then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            self.self_claims = resp.data.data.self_policies_claims;
            self.nominated_claims = resp.data.data.nominated_policies_claims;
            self.self = resp.data.data.self_policies_claims;
            self.nominated = resp.data.data.nominated_policies_claims;
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      filterSearchClaim(key) {
        const self = this;
        if (self.current_state == 'self') {
          self.self = self.self_claims.filter((x) =>
            x.product_name.toLowerCase().includes(key.target.value.toLowerCase())
          );
        } else {
          self.nominated = self.nominated_claims.filter((x) =>
            x.product_name.toLowerCase().includes(key.target.value.toLowerCase())
          );
        }
      },
      claimsFilter: function(e) {
        const self = this;
        self.self_claims_area = !self.self_claims_area;
        self.nominated_claims_area = !self.nominated_claims_area;
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/views/ComplaintFeedback/Feedback/Index.vue